import styled from 'styled-components';
import { Pagination as PaginationAntd, Select as SelectAntd } from 'antd';
import color from '../../configs/color';
import boxShadow from '../../configs/boxShadow';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  padding: 18px 24px;
  border-radius: 12px;
  box-shadow: ${(props) => {
    return props.noShadow ? 'none' : boxShadow.normal;
  }};
  margin-bottom: 24px;
`;

export const Select = styled(SelectAntd)`
  margin: 0 12px;
  color: ${color.black2};
  border-color: ${color.grey2};
  .ant-select-selector {
    border-color: ${color.grey2} !important;
    border-radius: 4px !important;
  }
`;

export const Pagination = styled(PaginationAntd)`
  .ant-pagination-item {
    border-color: ${color.grey1};
    border-radius: 8px;
    font-weight: 600;
    a {
      color: ${color.black2};
    }
  }
  .ant-pagination-item:focus-visible a,
  .ant-pagination-item:hover a {
    color: ${color.green1};
  }
  .ant-pagination-item-active {
    border-color: ${color.green1};
    border-radius: 8px;
    background-color: ${color.green1};
    color: ${color.white};
  }
  .ant-pagination-item-active a {
    color: ${color.white};
    font-weight: 600;
    :hover {
      color: ${color.white};
    }
  }

  .ant-pagination-item:focus-visible,
  .ant-pagination-item:hover {
    border-color: ${color.green1};
    color: ${color.green1};
  }

  .ant-pagination-prev .ant-pagination-item-link,
  .ant-pagination-next .ant-pagination-item-link {
    border-radius: 8px;
    border-color: ${color.grey1};
  }
`;

export default Wrapper;
